import { useMemo } from 'react'

import { RoomFilter } from 'shared/api/tours/search'

interface Option {
  value: string
  label: string
}

const mapToOptions = <T>(
  items: T[] | undefined,
  mapper: (item: T) => Option,
): Option[] => items?.map(mapper) ?? []

export const usePreparedRoomFilters = (tourFilterData?: RoomFilter) => {
  return useMemo(() => {
    if (!tourFilterData) {
      return {
        preparedMeal: [] as Option[],
        preparedOperators: [] as Option[],
        preparedRoomTypes: [] as Option[],
      }
    }

    const { meal_type, operators, room_types } = tourFilterData

    const preparedMeal = mapToOptions(meal_type, (item) => ({
      value: item.code,
      label: item.name,
    }))

    const preparedOperators = mapToOptions(operators, (item) => ({
      value: String(item.id),
      label: item.name,
    }))

    const preparedRoomTypes = mapToOptions(room_types, (item) => ({
      value: item,
      label: item,
    }))

    return { preparedMeal, preparedOperators, preparedRoomTypes }
  }, [tourFilterData])
}
